
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_LOCALE_MSGS = 'CHANGE_LOCALE_MSGS';
export const TRANSLATIONS_FETCH_REQUEST = 'TRANSLATIONS_FETCH_REQUEST';
